import { gql } from '@apollo/client'
import { NOTIFICATION_FIELDS } from './fragments/notification'

export const COMPLETE_LIVE_NOTIFICATION = gql`
  ${NOTIFICATION_FIELDS}
  mutation completeLiveNotification($id: ID!) {
    completeLiveNotification(id: $id) {
      id
      notification {
        ...NotificationFields
      }
    }
  }
`
